import { useContext, useEffect, useState } from 'react';
import api from '../api';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import { getError } from '../utils';
import { useTranslation } from 'react-i18next';

export default function ForgotPasswordScreen() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const { state } = useContext(Store);
  const { userInfo } = state;

  const currentLanguage = i18n.language; // Gets the current language

  useEffect(() => {
    if (userInfo) {
      navigate('/');
    }
  }, [navigate, userInfo]); // if the user already exists (is signed in), he can't access this Screen

  const submitHandler = async (e) => {
    e.preventDefault(); // prevents a page refresh when the form will be submited
    setLoading(true);
    try {
      const { data } = await api.post('/api/users/forgot-password', {
        email,
        language: currentLanguage,
      }); // a backend request to get a reset password link, based on the users email
      toast.success(t(data.message));
      navigate('/signin');
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || t('forgot-password-screen-reset-error');
      if (errorMessage.includes('limit-reached')) {
        toast.warning(t('forgot-password-screen-limit-reached'));
      } else if (errorMessage.includes('one-request-per-hour')) {
        toast.warning(t('forgot-password-screen-one-request-per-hour'));
      } else {
        toast.error(t(getError(err)));
      }
    }
    setLoading(false);
  };

  return (
    <Container className="small-container">
      <title>{t('forgot-password-screen-helmet')}</title>

      <h1 className="screen-heading">{t('forgot-password-screen-heading')}</h1>

      <Form className="forgot-password-form" onSubmit={submitHandler}>
        <Form.Group controlId="email">
          <Form.Label>{t('forgot-password-screen-email')}</Form.Label>

          <Form.Control
            className="mobile-device-compatible-top"
            type="email"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>

        <div className="submit-forgot-password-form-container">
          <Button variant="secondary" type="submit" disabled={loading}>
            {loading
              ? t('forgot-password-screen-reset-loading')
              : t('forgot-password-screen-reset')}
          </Button>
        </div>
      </Form>
    </Container>
  );
}
